const about_long_des = {
  text: 
  `<p>Here at Wheatley Hill Dental Surgery our passionate steadfast team of 10 are commited to ensuring a gold standard of care is consistently delivered.</p>
 <p>  We pride ourself on the vast array of treatments we can provide by our skilled clinicians.</p>
 <p>   We believe the best possible smile service is a must and the continual trust you have given us proves that we work to our belief’s and stay true to our values.</p> 
 <p>  In 2024 Wheatley Hill Dental Surgery reaches its outstanding 100 years of service milestone. </p>
 <p> We owe the pleasures of our success to you, our patients that continue to rely on the high standard of care our dedicated team provides.</p>`,
};

export default about_long_des;
